import { feedbackKeys } from 'plugin/virtual-braindate/setting/virtualBraindateSettings';
import messages from 'src/shared/app/base/component/data-entry/form-builder/l10n/formBuilderL10n';

const defaultFieldsData = [
  {
    key: 'how_would_you_rate_your_braindate_conversation',
    label_intl: messages.feedbackLabelRating,
    field_type: 'rating',
  },
  {
    key: 'which_of_the_following_did_you_experience_on_your_braindate',
    label_intl: messages.feedbackLabelExperience,
    choices: [
      {
        key: feedbackKeys.insight_check,
        label_intl: messages.feedbackLabelInsight,
      },
      {
        key: feedbackKeys.valuable_check,
        label_intl: messages.feedbackLabelValuable,
      },
      {
        key: feedbackKeys.profession_check,
        label_intl: messages.feedbackLabelProfession,
      },
      {
        key: feedbackKeys.personnal_check,
        label_intl: messages.feedbackLabelPersonnal,
      },

      {
        key: feedbackKeys.nobenefits_check,
        label_intl: messages.feedbackLabelNobenefits,

        more: [
          {
            key: feedbackKeys.nobenefits_more,
            field_type: 'text',
            label_intl: messages.feedbackLabelNobenefitsMore,
          },
        ],
      },

      {
        key: feedbackKeys.other_check,
        label_intl: messages.feedbackLabelOther,

        more: [
          {
            key: feedbackKeys.other_more,
            field_type: 'text',
            label_intl: messages.feedbackLabelOtherMore,
          },
        ],
      },
    ],
    field_type: 'checkbox_list',
  },
  {
    key: feedbackKeys.more,
    label_intl: messages.feedbackLabelMore,

    field_type: 'text',
  },
];

export default defaultFieldsData;
